module.exports = __webpack_public_path__ + "img/bluesky32.0380cc76.jpg";